import { conditionType } from "./condition.constants"

export const conditionModel = {
    sourceId: 0,
    operator: '',
    value: '',
    sortNo: 0,
    action:"",
    prefix:"", 
    suffix:"",
}

/* export const conditionGroupModel = {
    groupId: 0,
    sortNo: 0,
    
}

export const conditionQueryModel ={

} */